// extracted by mini-css-extract-plugin
export default {"email_campign_signup_container":"SignupEmailCampign_email_campign_signup_container__yf19+","thanku_text":"SignupEmailCampign_thanku_text__5s5ba"};